import React from 'react';

export default function Card({ className = '', padded = true, children, ...rest }) {
  return (
    <div
      className={`bg-white rounded-xl shadow-card border border-gray-100 ${padded ? 'p-6' : ''} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
